import styled from 'styled-components'
import { HiMiniChatBubbleOvalLeft } from 'react-icons/hi2'
import { TextWidth } from '@ta-interaktiv/react-disco-grid'

const Examples = () => {
  return (
    <Container>
      <TextWidth>
        <strong>Par exemple:</strong>
        <Example>
          <Icon />
          Quelles sont les dernières mesures prises pour le logement abordable à
          Genève ?
        </Example>
      </TextWidth>
    </Container>
  )
}

const Container = styled.div`
  background-color: ${({ theme }) => theme.colorGreyLight};
  padding: 2rem 0;
`

const Icon = styled(HiMiniChatBubbleOvalLeft)`
  position: absolute;
  left: 2rem;
  top: 1.85rem;
  font-size: 2.5rem;
  color: var(--text-color);
  opacity: 0.25;
`

const Example = styled.div`
  position: relative;
  padding: 2rem;
  border: 1px solid ${({ theme }) => theme.colorGrey};
  background-color: ${({ theme }) => `${theme.colorSiteBackground}88`};
  border-radius: 1rem;
  margin-top: 1rem;
  padding-left: 5.45rem;
  line-height: 1.4;
`

export default Examples
